import { render } from "./PostVideoPlayer.vue?vue&type=template&id=4670310c&scoped=true"
import script from "./PostVideoPlayer.vue?vue&type=script&lang=js"
export * from "./PostVideoPlayer.vue?vue&type=script&lang=js"

import "./PostVideoPlayer.vue?vue&type=style&index=0&id=4670310c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4670310c"

export default script